// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3SiRP","errorLogs":"styles_errorLogs__H2Idh"};